<template lang="html">

  <section class="historia-infografia">
    <router-link :to="$t('enlaces.home')" class=" link-close justify-end">
      <img class="close-white" src="/static/img/historia_infografia/close-white.svg" alt="" width="44" height="43" loading="lazy">
      <img class="close-blue d-none" src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
    </router-link>
    <button @click="moveSectionUp" class="arrow-prev"></button>
    <button @click="moveSectionDown" class="arrow-next -blue"></button>
    <!-- <select v-model="$i18n.locale" class="select-idioma-lang">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang }}
          </option>
        </select> -->
    <div class="historia--wrapper">
      <full-page ref="fullpage" :options="options" id="fullpage">

        <article class="section page page-0">
          <!--
            La infografia no tiene ningun titulo textual: se apoya en video e
            imagenes. Este h1 da a la pagina su encabezado sin alterar el diseno,
            y lo aprovechan tanto los buscadores como los lectores de pantalla.
          -->
          <h1 class="titulo-accesible">{{ $t('enlaces.textos.aniversario50') }} {{ $t('enlaces.textos.ajusa') }}</h1>
          <div class="locale-changer">

          </div>
          <!--
            Antes era un GIF de 4 MB. En MP4 el mismo contenido ocupa 280 KB, y
            `autoplay muted loop playsinline` lo hace comportarse igual que un
            GIF, sin controles y sin abrirse a pantalla completa en iOS.
          -->
          <div class="video-resp">
            <video src="/static/img/historia_infografia/intro.mp4" width="700" height="394"
              autoplay muted loop playsinline></video>
          </div>
          <video muted autoplay loop class="video-intro">
            <source :src="$t('historia_infografia.urlVideoIntro')">
          </video>
        </article>
        <article class="section page page-1">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline-aniversario">
                <div class="col-50 mask  flex column justify-center box-more-info align-center"> </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div class="title-celebracion"  v-html="$t('historia_infografia.celebracion50')"></div>
                      <div class="flex column align-end text-right div-celebracion">
                        <p>{{$t('historia_infografia.celebracion50descripcion')}}</p>
                        <div class="box-links">
                          <a target="_blank" href="https://www.youtube.com/watch?v=B6i5LFboYz4">{{$t('historia_infografia.video')}}</a>
                          <a target="_blank" href="http://www.jaimeboira.com/ajusa50/">{{$t('historia_infografia.galeria')}}</a>
                          <a target="_blank" :href="$t('historia_infografia.urlNoticias')">{{$t('historia_infografia.noticias')}}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-2">
          <div class="container-intro-texto container">
            <p class="title animated" data="fadeInDown" v-html="$t('historia_infografia.Anios50')"></p>
            <p class="subtitle animated" data="fadeInDown" v-html="$t('historia_infografia.excedencia')"></p>
            <p class="description animated" data="fadeInUp" v-html="$t('historia_infografia.enAutomocion')"></p>
          </div>
        </article>
        <article class="section page page-3">
          <div class="container-intro-texto container">
            <p class="title animated" data="fadeInDown" v-html="$t('historia_infografia.albacete')"></p>
            <p class="description animated" data="fadeInUp" v-html="$t('historia_infografia.laCuidad')"></p>
            <p class="subtitle animated text-right w-100" data="fadeInDown" v-html="$t('historia_infografia.crecer')"></p>
          </div>
        </article>
        <article class="section page page-4">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1950-1">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc">
                        <p class="title" v-html="$t('historia_infografia.mayorAntesDeTiempo')"></p>
                        <p v-html="$t('historia_infografia.textMayor')"></p>
                      </div>
                      <div class="flex column align-end text-right">
                        <img src="/static/img/historia_infografia/1950/1950-2.webp" alt="" width="562" height="786" loading="lazy">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div>
                        <div class="number-hologram">I<span>95</span>0</div>
                      </div>
                      <div class="flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.eraseUnaVez')"></p>
                        <p v-html="$t('historia_infografia.textEraseUnaVez')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-5">
          <div class="view vertical">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1964">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc">
                        <p class="title" v-html="$t('historia_infografia.unGestoInolvidable')"></p>
                        <p class="text-center" v-html="$t('historia_infografia.enEsteTrabajo')"></p>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color pos-initial">
                    <div class="container flex column">
                      <div class="animated" data="fadeInLeft">
                        <div class="number-hologram">I<span>9</span><span class="top">6</span></span>4</div>
                      </div>
                      <div class="flex column align-start text-left width-reduc">
                        <p class="title animated" data="fadeInLeft" v-html="$t('historia_infografia.aprendiendoElOficio')"></p>
                        <p v-html="$t('historia_infografia.con14Anios')" class="animated" data="fadeInLeft"></p>
                        <span class="btn-pink animated" data="fadeInLeft" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-6">
          <div class="view horizontal -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1969-1">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between align-end">
                      <div>
                        <div class="number-hologram">I<span>9</span><span class="top">6</span>9</span></div>
                      </div>
                      <div class="flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.granImplicacion')"></p>
                        <p v-html="$t('historia_infografia.fueronAnios')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-between">
                      <div class="flex column align-center text-left justify-center">
                        <p v-html="$t('historia_infografia.fueronMeses')"></p>
                      </div>
                      <div class="flex column align-end text-right">
                        <img src="/static/img/historia_infografia/1969/1969-2.webp" alt="" width="528" height="365" loading="lazy">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-7">
          <div class="view vertical -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1972">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="flex column align-end justify-center">
                      <div>
                        <div class="number-hologram">I<span>97</span><span class="top"></span></span>2</div>
                      </div>
                      <div class="flex column align-end text-right width-reduc">
                        <p class="title" v-html="$t('historia_infografia.naceAjusa')"></p>
                        <p v-html="$t('historia_infografia.suEspiritu')"></p>
                        <p v-html="$t('historia_infografia.naceLaCompania')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-start" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc text-center">
                        <img src="/static/img/historia_infografia/1972/1972-1.webp" alt="" width="501" height="347" loading="lazy">
                        <p v-html="$t('historia_infografia.miguelOliver')"> </p>
                        <p v-html="$t('historia_infografia.primeraJuntas')"></p>

                        <p v-html="$t('historia_infografia.seTardada')"></p>
                        <p v-html="$t('historia_infografia.primeraEtapa')">
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-8">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1973">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -white column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center">
                        <p class="title" v-html="$t('historia_infografia.contanciaEsfuerzo')"></p>
                        <p v-html="$t('historia_infografia.josemaRecorrio')"></p>
                      </div>
                      <div class="flex column align-center text-right portadas-box">
                        <slick class="slider-container" :options="slickOptions">
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1973-1.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 01</strong> | 1973</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1975-2.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 02</strong> | 1975</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1982-3.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 03</strong> | 1982</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1986-4.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 04</strong> | 1986</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1988-5.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 05</strong> | 1988</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1990-6.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 06</strong> | 1990</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1992-7.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 07</strong> | 1992</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1994-8.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 08</strong> | 1994</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1996-9.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 09</strong> | 1996</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1998-10.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 10</strong> | 1998</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/1920-11.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 11</strong> | 2000</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2002-12.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 12</strong> | 2002</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2004-13.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 13</strong> | 2004</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2006-14.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 14</strong> | 2006</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2008-15.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 15</strong> | 2008</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2010-16.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 16</strong> | 2010</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2012-17.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 17</strong> | 2012</p>
                            </div>
                          </div>

                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2014-19.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 18</strong> | 2015</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2016-20.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 19</strong> | 2016</p>
                            </div>
                          </div>

                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2018-21.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 20</strong> | 2018</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2020-22.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 21</strong> | 2020</p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1973/2022-23.webp" alt="" width="272" height="391" loading="lazy">
                              <p class="text-center"><strong>{{$t('historia_infografia.edicion')}} 22</strong> | 2022</p>
                            </div>
                          </div>
                        </slick>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div>
                        <div class="number-hologram">I<span>97</span><span class="top">3</span></div>
                      </div>
                      <div class="flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.catalogoAjusa')"></p>
                        <p v-html="$t('historia_infografia.infoCatalogo')"></p>
                        <span class="btn-white" @click="openMoreInfo" v-html="$t('historia_infografia.verPortadas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-9">
          <div class="view vertical">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1974">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc">
                        <slick class="slider-container" :options="slickOptions">
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1974/1974-01.webp" alt="" width="519" height="359" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1974/1974-02.webp" alt="" width="519" height="360" loading="lazy">
                            </div>
                          </div>
                        </slick>
                        <p class="text-center" v-html="$t('historia_infografia.textInfo1974')"></p>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex column">
                      <div>
                        <div class="number-hologram">I<span>97</span></span>4</div>
                      </div>
                      <div class="flex column align-start text-left width-reduc">
                        <p class="title" v-html="$t('historia_infografia.amorAPrimera')"></p>
                        <p v-html="$t('historia_infografia.descriptAmor')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-10">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1976">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <slick class="slider-container" :options="slickOptions">
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-1.webp" alt="" width="525" height="346" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-2.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-3.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-4.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-5.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-6.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-7.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-8.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1976/1976-9.webp" alt="" width="502" height="347" loading="lazy">
                          </div>
                        </div>
                      </slick>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div class="cont-1976-1">
                        <div class="number-hologram">I<span>97</span><span class="top">6</span></div>
                      </div>
                      <div class="cont-1976-2 flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.crecimientoImparable')"></p>
                        <p v-html="$t('historia_infografia.text1crecimientoImparable')"></p>
                        <p v-html="$t('historia_infografia.text2crecimientoImparable')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.verMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-11">
          <div class="view vertical -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1978">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="flex column align-end justify-center align-center">
                      <div>
                        <div class="number-hologram">I<span>97</span><span class="top"></span></span>8</div>
                      </div>
                      <div class="flex column align-end text-right width-reduc">
                        <p class="title" v-html="$t('historia_infografia.title1978')"></p>
                        <p v-html="$t('historia_infografia.description1_1978')"></p>
                        <p v-html="$t('historia_infografia.description2_1978')"></p>
                        <p v-html="$t('historia_infografia.description3_1978')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.verMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-start" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center align-center">
                      <slick class="slider-container" :options="slickOptions">
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-1.webp" alt="" width="519" height="360" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-2.webp" alt="" width="519" height="359" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-3.webp" alt="" width="517" height="358" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-4.webp" alt="" width="518" height="359" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-5.webp" alt="" width="518" height="360" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="flex column align-center justify-center">
                            <img src="/static/img/historia_infografia/1978/1978-6.webp" alt="" width="518" height="360" loading="lazy">
                          </div>
                        </div>
                      </slick>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-12">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1980">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-end text-right">
                        <img src="/static/img/historia_infografia/1980/1980-1.webp" alt="" width="515" height="373" loading="lazy">
                      </div>
                      <div class="flex column align-center text-center justify-center width-reduc">
                        <p class="title" v-html="$t('historia_infografia.importanteReconociento')"></p>
                        <p v-html="$t('historia_infografia.espirituInnovador')"></p>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div class="cont-1980-1">
                        <div class="number-hologram">I<span>98</span>0</div>
                      </div>
                      <div class="flex column align-end text-right cont-1980-2">
                        <p class="title" v-html="$t('historia_infografia.title1980')"></p>
                        <p v-html="$t('historia_infografia.description1_1980')"></p>
                        <p v-html="$t('historia_infografia.description2_1980')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-13">
          <div class="view horizontal -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1992">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between align-end">
                      <div>
                        <div class="number-hologram">I<span>99</span>2</span></div>
                      </div>
                      <div class="flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.title1992')"></p>
                        <p v-html="$t('historia_infografia.description1_1992')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-between">
                      <div class="flex column align-center text-left justify-center">
                        <p class="title" v-html="$t('historia_infografia.calidadGarantizada')"></p>
                        <p v-html="$t('historia_infografia.ajusaEmpresaPionera')"></p>
                        <p v-html="$t('historia_infografia.primeraEmpresaSector')"></p>
                      </div>
                      <div class="flex column align-end text-right overflow-hidden">
                        <slick class="slider-container w-100" :options="slickOptions">
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-1.webp" alt="" width="507" height="352" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-2.webp" alt="" width="505" height="350" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-3.webp" alt="" width="506" height="350" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-4.webp" alt="" width="506" height="350" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-5.webp" alt="" width="506" height="350" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-6.webp" alt="" width="506" height="350" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/1992/1992-7.webp" alt="" width="506" height="350" loading="lazy">
                            </div>
                          </div>
                        </slick>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-14">
          <div class="view vertical -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline1996">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex column align-end justify-center">
                      <div>
                        <div class="number-hologram">I<span>99</span>6</div>
                      </div>
                      <div class="flex column align-end text-right width-reduc">
                        <p class="title" v-html="$t('historia_infografia.title1996')"></p>
                        <p v-html="$t('historia_infografia.description1_1996')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-start" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc text-center">
                        <img src="/static/img/historia_infografia/1996/1996-1.webp" alt="" class="w-100" width="1920" height="1350" loading="lazy">
                        <br>
                        <p class="title" v-html="$t('historia_infografia.eeuuPrimeraSucursal')"></p>
                        <p v-html="$t('historia_infografia.sucursalEeuu')">
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-15">
          <div class="view vertical">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline2002">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc">

                        <p class="title" v-html="$t('historia_infografia.comprometidosSostenibilidad')"></p>
                        <p class="text-center" v-html="$t('historia_infografia.infocomprometidosSostenibilidad')"></p>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex column">
                      <div>
                        <div class="number-hologram">2002</div>
                      </div>
                      <div class="flex column align-start text-left width-reduc">
                        <p class="title" v-html="$t('historia_infografia.title2002')"></p>
                        <p v-html="$t('historia_infografia.description2002')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-16">
          <div class="view horizontal">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline2008">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -white column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center">
                        <p class="title" v-html="$t('historia_infografia.actualizamosLogo')"></p>
                        <p v-html="$t('historia_infografia.evolucionG')"></p>
                      </div>
                      <div class="flex column align-center text-right ">
                        <slick class="slider-container w-100" :options="slickOptions">
                          <div class="slide">
                            <div class="flex column align-center justify-center logos-box">
                              <img src="/static/img/historia_infografia/2008/2008-1.svg" alt="" class="w-100" width="438" height="160" loading="lazy">
                              <p class="text-center"><strong>1972</strong></p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center logos-box">
                              <img src="/static/img/historia_infografia/2008/2008-2.svg" alt="" class="w-100" width="473" height="114" loading="lazy">
                              <p class="text-center"><strong>1982</strong></p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center logos-box">
                              <img src="/static/img/historia_infografia/2008/2008-3.svg" alt="" class="w-100" width="415" height="103" loading="lazy">
                              <p class="text-center"><strong>1988</strong></p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center logos-box">
                              <img src="/static/img/historia_infografia/2008/2008-4.svg" alt="" class="w-100" style="max-width:400px" width="422" height="145" loading="lazy">
                              <p class="text-center"><strong>1994</strong></p>
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center logos-box">
                              <img src="/static/img/historia_infografia/2008/2008-5.svg" alt="" class="w-100" style="max-width:350px" width="355" height="142" loading="lazy">
                              <p class="text-center"><strong>2008</strong></p>
                            </div>
                          </div>
                        </slick>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between ">
                      <div>
                        <div class="number-hologram">2008</span></div>
                      </div>
                      <div class="flex column align-end text-right">
                        <p class="title" v-html="$t('historia_infografia.title2008')"></p>
                        <p v-html="$t('historia_infografia.description1_2008')"></p>
                        <p v-html="$t('historia_infografia.description2_2008')"></p>
                        <span class="btn-white" @click="openMoreInfo" v-html="$t('historia_infografia.cuentameMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-17">
          <div class="view vertical">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline2014">
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -pink column">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center">
                      <div class="flex column align-center text-center justify-center width-reduc w-100">
                        <slick class="slider-container w-100" :options="slickOptions">
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-1.webp" class="w-100" alt="" width="519" height="360" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-2.webp" class="w-100" alt="" width="519" height="360" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-3.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-4.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-5.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-6.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-7.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-8.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-9.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                          <div class="slide">
                            <div class="flex column align-center justify-center">
                              <img src="/static/img/historia_infografia/2014/2014-10.webp" class="w-100" alt="" width="523" height="362" loading="lazy">
                            </div>
                          </div>
                        </slick>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex-column">
                      <div>
                        <div class="number-hologram">2014</div>
                      </div>
                      <div class="flex column align-start text-left width-reduc">
                        <p class="title" v-html="$t('historia_infografia.title2014')"></p>
                        <p v-html="$t('historia_infografia.description1_2014')"></p>
                        <p v-html="$t('historia_infografia.description2_2014')"></p>
                        <span class="btn-pink" @click="openMoreInfo" v-html="$t('historia_infografia.verMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-18">
          <div class="view horizontal -reverse">
            <div class="view__inner">
              <div class="flex wrap row-reverse justify-center time-wrap timeline2022">
                <div class="col-50 mask flex column justify-center">
                  <div class="color">
                    <div class="container flex row justify-between align-start">
                      <div class="cont-2002-1">
                        <div class="number-hologram">2022</div>
                      </div>
                      <div class="flex column align-end text-right cont-2002-2">
                        <p class="title" v-html="$t('historia_infografia.title2022')"></p>
                        <p v-html="$t('historia_infografia.description1_2022')"> </p>
                        <p v-html="$t('historia_infografia.description2_2022')"></p>
                        <span class="btn-yellow" @click="openMoreInfo" v-html="$t('historia_infografia.verMas')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-50 mask  flex column justify-center box-more-info align-center">
                  <div class="color -yellow column photos-2022">
                    <div class="close-btn justify-end" @click="closeMoreInfo">
                      <img src="/static/img/historia_infografia/icon-close.svg" alt="" width="44" height="44" loading="lazy">
                    </div>
                    <div class="container flex row justify-center" style="padding-top: 0;">
                      <slick class="slider-container" :options="slickOptions">
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-1.webp" alt="" width="1920" height="1793" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-2.webp" alt="" width="1920" height="2621" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-3.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-4.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-5.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>

                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-6.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-7.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-8.webp" alt="" width="1920" height="2879" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-9.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-10.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-11.webp" alt="" width="1920" height="1017" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-12.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-13.webp" alt="" width="1920" height="2476" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-14.webp" alt="" width="1920" height="1189" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-15.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                        <div class="slide">
                          <div class="box-photos">
                            <img src="/static/img/historia_infografia/2022/2022-16.webp" alt="" width="1920" height="1281" loading="lazy">
                          </div>
                        </div>
                      </slick>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="section page page-19 column">
          <div class="flex justify-center align-center column">
            <video class="video-full" id="VideoFull">
              <source :src="$t('historia_infografia.urlVideoCompl')" type="video/mp4">
            </video>
            <div class="flex justify-center align-center">
              <div class="btn-white-border" @click="playVideo()" v-html="$t('historia_infografia.verVideo')">
              </div>
            </div>
          </div>
        </article>
      </full-page>
    </div>
  </section>

</template>

<script lang="js">
  import 'animate.css'
  import Vue from 'vue'
  import 'fullpage.js/vendors/scrolloverflow'
  // import './fullpage.scrollHorizontally.min'
  import VueFullPage from 'vue-fullpage.js'
  import Slick from 'vue-slick';
  Vue.use(VueFullPage);
  export default {
    name: 'test',
    props: [],
    components: {
      'slick': Slick,
    },
    mounted() {

    },
    data() {
      return {
        langs: ['es', 'en'],
        slickOptions: {
          slidesToShow: 1,
          arrows: true
        },
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          onLeave: function (prev, next, direction) {
            console.log('leave')
            $(".animated").each(function (index) {
              $(this).removeClass($(this).attr('data'))
              $(this).removeClass('active')
            });
          },
          afterLoad: function (prev, next, direction) {
            console.log(next.index)
            $(".page").removeClass('active-page');
            $(`.page-${next.index}`).addClass('active-page');
            $(".page .view").removeClass('slick-active');
            $(`.page-${next.index} .view`).addClass('slick-active');
            $(`.timeline__item`).removeClass('timeline__item--active');
            $(`.timeline__item`).eq(next.index).addClass('timeline__item--active');
            $('.box-more-info').removeClass('active')
            $(".animated").each(function (index) {
              $(this).addClass($(this).attr('data'))
              $(this).addClass('active')
            });

            if ($('.page.page-0').hasClass('active-page')) {
              $('.arrow-next').addClass('-blue')
              $('.arrow-prev').removeClass('active')
              $('.close-blue').removeClass('d-none')
              $('.close-white').addClass('d-none')

            } else {
              $('.arrow-prev').addClass('active')
              $('.arrow-next').removeClass('-blue')
              $('.close-blue').addClass('d-none')
              $('.close-white').removeClass('d-none')

            }
            if ($('.page.page-19').hasClass('active-page')) {
              $('.arrow-prev').addClass('-blue')
              $('.arrow-next').addClass('d-none')
              $('.close-blue').removeClass('d-none')
              $('.close-white').addClass('d-none')

            } else {
              $('.arrow-prev').removeClass('-blue')
              $('.arrow-next').removeClass('d-none')


            }
          }
        },
      }
    },
    methods: {
      moveSectionDown() {
        fullpage_api.moveSectionDown();
      },
      //this.$refs.example.$fullpage.moveSectionDown()
      moveSectionUp() {
        fullpage_api.moveSectionUp();
      },
      openMoreInfo() {
        event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(".box-more-info").classList.add("active");
        $('.link-close').addClass('d-none')
      },
      closeMoreInfo() {
        event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(".box-more-info").classList.remove("active");
        $('.link-close').removeClass('d-none')
      },
      playVideo() {
        var movie = $('.video-full').get(0);
        $('.video-full').attr('controls', true)
        movie.play();

      }
    },
    computed: {

    }
  }
</script>

<style>
  .select-idioma-lang {
    position: fixed;
    z-index: 88;
    left: 20px;
    top: 20px;
    border: 0;
    padding: 3px 10px;
    text-transform: uppercase;
    border: 0;
    background: rgba(0, 61, 166, 0.75);
    color: white;
    border: 1px solid white;
    cursor: pointer;
  }

  .select-idioma-lang:focus {
    outline: none;
  }

  /*
    Oculta el titulo visualmente pero lo mantiene en el arbol de accesibilidad y
    en el HTML que rastrean los buscadores. No se usa `display: none` ni
    `visibility: hidden` porque ambos lo retirarian tambien de ahi.
  */
  .titulo-accesible {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/historia-infografia.vue